import { Box } from '@mui/material'
import CustomDialog from 'components/CustomDialog'
import SimpleBarScroll from 'components/SimpleBar'
import React from 'react'
import CreateCustomer from './CreateCustomer'

const CustomerProfileUpdateDialog = ({ open, handleClose, customer }) => {
  return (<CustomDialog
    forceFullScreen={false}
    open={open}
    handleClose={handleClose}
    heading="Edit customer"
  >
    <Box sx={{ overflow: "hidden" }}>
      <SimpleBarScroll>
        <Box padding={2}>
          <CreateCustomer customer={customer} />
        </Box>
      </SimpleBarScroll>
    </Box>
  </CustomDialog>
  )
}

export default CustomerProfileUpdateDialog